import React from 'react';
import { Calendar, Search, Wrench, CheckCircle } from 'lucide-react';
export function ProcessStrip() {
  const steps = [{
    icon: Calendar,
    title: 'Book',
    description: 'Schedule your visit'
  }, {
    icon: Search,
    title: 'Diagnose',
    description: 'Identify the issue'
  }, {
    icon: Wrench,
    title: 'Repair',
    description: 'Fix the problem'
  }, {
    icon: CheckCircle,
    title: 'Test',
    description: 'Verify it works'
  }];
  return <section className="py-16 bg-white" data-id="element-302">
      <div className="max-w-7xl mx-auto px-4" data-id="element-303">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-900" data-id="element-304">
          How It Works
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-305">
          {steps.map((step, index) => <div key={index} className="text-center" data-id="element-306">
              <div className="relative mb-6" data-id="element-307">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-[#0D7377] rounded-full mb-4" data-id="element-308">
                  <step.icon className="text-white" size={32} data-id="element-309" />
                </div>
                {index < steps.length - 1 && <div className="hidden md:block absolute top-10 left-[60%] w-full h-0.5 bg-[#8FB996]" data-id="element-310"></div>}
              </div>
              <h3 className="font-semibold text-xl mb-2 text-gray-900" data-id="element-311">
                {step.title}
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-312">{step.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}